import { render, staticRenderFns } from "./Nossaflex.vue?vue&type=template&id=4751a072&scoped=true&"
var script = {}
import style0 from "./Nossaflex.vue?vue&type=style&index=0&id=4751a072&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4751a072",
  null
  
)

export default component.exports